import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["classes", "className", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { mergeStyles } from '../../utils/StyleUtils';
import withMemo from '../../decorators/withMemo';
import styles from './styles';
var useStyles = createUseStyles(styles);
var CookieSettingsButton = function CookieSettingsButton(props) {
  var classesProp = props.classes,
    className = props.className,
    children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  var classesComp = useStyles(props);
  var classes = React.useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  return /*#__PURE__*/React.createElement("button", _extends({
    id: "ot-sdk-btn",
    className: cx(classes.button, 'ot-sdk-show-settings', className),
    type: "button"
  }, otherProps), children);
};
CookieSettingsButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node
};
CookieSettingsButton.defaultProps = {
  className: null,
  classes: {},
  children: 'Cookie Settings'
};
export default withMemo()(CookieSettingsButton);